import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import '../../environments/rxjs-extensions';
import { HealtyAppService } from './bdb-identity-number/services/healthy-app.service';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { ActivatedRoute } from '@angular/router';
import * as packageData from '../../package.json';
import { SessionStorageKeysEnum } from './models/session-storage-keys-enum';
import { environment } from '../../environments/environment';
import { SandboxRequestService } from './shared/sandbox/sandbox-request.service';

const appVersion = (<any>packageData).version;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  @ViewChild('modal') modalBdb: ElementRef;
  modalFunctionYes: Function;

  constructor(
    private healthyService: HealtyAppService,
    private sessionStorageService: BdbSessionStrgService,
    private activateRoute: ActivatedRoute,
    private sandbox: SandboxRequestService,
  ) { }

  async ngOnInit() {
    this.activateRoute.queryParams.subscribe(async dat => {
      console.log('params: ', dat);
      await this.getAndSaveIps();
      if (dat.site !== undefined) {
        const site = dat.site;
        if (this.sessionStorageService.get(SessionStorageKeysEnum.SITE) !== site) {
          this.sessionStorageService.clear();
        }
        // Esto solo se ejecuta cuando tiene los query params
        await this.getVersionAuthenticator();
        Observable.interval(1000 * 60 * 5).subscribe(x => {
          this.getVersionAuthenticator();
        });
      }
    });
  }

  async getVersionAuthenticator() {
    console.log('appVersion', appVersion);
    const data = {
      'digitaProductId': '0',
      'digitaProductVersion': appVersion,
      'officeIp': this.sessionStorageService.get(SessionStorageKeysEnum.PUBLIC_IP),
    };
    await this.reloadIfIsDifferentVersion(data);
  }

  async reloadIfIsDifferentVersion(data) {
    const checkVersion = environment.useSandboxV3ToCheckVersion;
    if (checkVersion) {
      const url = `${environment.sandboxV3Domain}/auth/V1/product/authenticator/check-version/${appVersion}/verify`;
      try {
        const response = await this.sandbox.requestGetSandbox(url, {});

        if (response.status !== 200) {
          this.showModalError();
        }
      } catch (error) {
        this.showModalError();
      }
    } else {
      this.healthyService.getVersion(data).subscribe(response => {
        if (response.status === 200) {
          const jsonResponse = JSON.parse(response._body);
          const publishedVersion = jsonResponse.digitalProduct.version;
          console.log('publishedVersion', publishedVersion);
          if (appVersion !== publishedVersion) {
            // Es bueno que recargue hasta tener la versión adecuada!
            // Si el autenticador no está actualizado no se puede certificar que todo funcione como se espera.
            // Es mejor que recargue indefinidamente hasta que se actualice el código y la lambda BDB_Healthy_Front_Manager_Events.
            this.showModalError();
          } else {
            throw new Error('Falló la consulta de la versión de la aplicación en el Healthy Service.');
          }
        }
      });
    }
  }

  callModalOldVersion(currentVersion: string, callbackYes: Function) {
    this.modalFunctionYes = callbackYes;
    this.modalBdb.nativeElement.optionsButtons = [
      { id: '0', value: 'Aceptar' }
    ];
    this.modalBdb.nativeElement.subTitle = `La versión ${currentVersion} debe ser actualizada`
    this.modalBdb.nativeElement.titleModal = 'Debemos actualizar esta versión'
    this.modalBdb.nativeElement.icon = 'warning'
    this.modalBdb.nativeElement.isTimer = false
    this.modalBdb.nativeElement.openAlert();
  }

  showInactivityModal(timeElapsed: number): void {
    this.modalFunctionYes = () => { };
    this.modalBdb.nativeElement.optionsButtons = [
      { id: '0', value: 'Estoy acá ›' }
    ];
    this.modalBdb.nativeElement.subTitle = `La solicitud se cerrará`;
    this.modalBdb.nativeElement.titleModal = 'No hemos detectado actividad en los últimos minutos';
    this.modalBdb.nativeElement.icon = 'warning';
    this.modalBdb.nativeElement.isTimer = true;
    this.modalBdb.nativeElement.time = timeElapsed;
    setTimeout(() => {
      this.modalBdb.nativeElement.openAlert();
    }, 50)
  }

  async buttonsRedirection(event: any): Promise<void> {
    console.log('Redirecting', event.detail);
  }

  showModalError() {
    console.log('Actualice la versión en la Lambda para evitar recargas de la página! Versión actual: '
      + appVersion);
    const callbackOldVersion = () => {
      this.sessionStorageService.clear();
      location.reload();
    }
    this.callModalOldVersion(appVersion, callbackOldVersion);
//    setTimeout(callbackOldVersion, 10000);
  }

  actionButtomModalBdb(event: any) {
    this.modalFunctionYes();
  }

    private async getAndSaveIps() {

    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts